import research from "redux/reducers/research";

export const ResearchSelector = {
  state: (state) => state[research.name],
  loadingCategory: (state) => ResearchSelector.state(state).loadingCategory,
  categories: (state) => ResearchSelector.state(state).categories,
  activeCategory: (state) => ResearchSelector.state(state).activeCategory,
  research: (state) => ResearchSelector.state(state).research,
};
